import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MapControls = ({ onZoomIn, onZoomOut, onResetView, onToggleFullscreen, isFullscreen }) => {
  return (
    <div className="absolute bottom-4 right-4 flex flex-col gap-2 z-[400]">
      <Button
        variant="default"
        size="icon"
        onClick={onZoomIn}
        aria-label="Zoom in"
        className="shadow-conservation"
      >
        <Icon name="Plus" size={20} />
      </Button>
      
      <Button
        variant="default"
        size="icon"
        onClick={onZoomOut}
        aria-label="Zoom out"
        className="shadow-conservation"
      >
        <Icon name="Minus" size={20} />
      </Button>
      
      <Button
        variant="default"
        size="icon"
        onClick={onResetView}
        aria-label="Reset view"
        className="shadow-conservation"
      >
        <Icon name="Home" size={20} />
      </Button>
      
      <Button
        variant="default"
        size="icon"
        onClick={onToggleFullscreen}
        aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
        className="shadow-conservation"
      >
        <Icon name={isFullscreen ? 'Minimize2' : 'Maximize2'} size={20} />
      </Button>
    </div>
  );
};

export default MapControls;